import React from 'react';
import { useUser } from '@/hooks/useUser';
import { Link } from 'react-router';
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { LatestRecords } from '@/components/LatestRecords';
import { UpcomingEvents } from '@/components/UpcomingEvents';
import { StatsSection } from '@/components/StatsSection';
import { NotableRecords } from '@/components/NotableRecords';

export const UserHome: React.FC = () => {
  const { currentUser } = useUser();

  return (
    <div className="container mx-auto px-4 space-y-16">
      {/* Hero Section */}
      <section className="flex flex-col md:flex-row items-start gap-12 py-12 md:py-8">
        <div className="flex-1 space-y-6">
          <h1 className="text-5xl font-bold tracking-tight">
            Welcome back to <span className="text-primary">TytoBio</span>
          </h1>
          <p className="text-xl text-muted-foreground">
            Record, track, and share your sightings with your communities
          </p>

          {/* User Organisations */}
          <div className='flex flex-row flex-wrap gap-4'>
            {currentUser?.organisations?.length ? (
              <>
                {currentUser.organisations.map(org => (
                  <Button
                    key={org.orgId}
                    asChild
                    variant="outline"
                    size="lg"
                    className="flex items-center gap-2"
                  >
                    <Link to={`/app/org/${org.orgId}`}>
                      {org.logoUrl && (
                        <img src={org.logoUrl} alt={org.orgName} className="w-6 h-6 rounded-full" />
                      )}
                      {org.orgName}
                    </Link>
                  </Button>
                ))}
              </>
            ) : null}
          </div>
          <div className="flex flex-wrap gap-4">
            <Button asChild size="lg">
              <Link to="/app/create">Create a new community</Link>
            </Button>
            <Button variant="outline" asChild size="lg">
              <Link to="/app/explore">Explore organisations</Link>
            </Button>

          </div>
        </div>
        <div className="w-full md:w-1/2">
          <LatestRecords />
        </div>
      </section >

      {/* Features Section */}
      < section className="py-12" >
        <UpcomingEvents />
      </section >

      {/* Stats Section */}
      <StatsSection />

      {/* Recent Sightings Section */}
      {/* <NotableRecords /> */}

    </div >
  );
};
